module.exports = __webpack_public_path__ + "static/media/tom-ford-fucking-fabulous-big.960c6d13.png";